import { Component, Input } from '@angular/core';
import { RetailPayoutStatus } from '@galaxy/billing';
import { VaBadgeModule } from '@vendasta/uikit';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'smb-invoicing-payout-status-badge',
  templateUrl: './payout-status-badge.component.html',
  styleUrls: ['./payout-status-badge.component.scss'],
  standalone: true,
  imports: [VaBadgeModule, MatIcon, MatTooltip],
})
export class PayoutStatusBadgeComponent {
  @Input() status: RetailPayoutStatus;
  @Input() failureMessage: string;

  get text(): string {
    return this.status;
  }

  get color(): string {
    switch (this.status) {
      case RetailPayoutStatus.Paid:
        return 'green';
      case RetailPayoutStatus.Pending:
        return 'light-gray';
      case RetailPayoutStatus.InTransit:
        return 'yellow';
      case RetailPayoutStatus.Canceled:
      case RetailPayoutStatus.Failed:
        return 'red';
    }
    return '';
  }

  get isError(): boolean {
    return this.status === RetailPayoutStatus.Failed;
  }
}
